<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-6">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="webhook.nome" />
        </div>
        <div class="col-md-6">
          <label>URL</label>
          <input
            type="text"
            class="form-control"
            v-model="webhook.url"
            placeholder="https://parceiro.com.br/receber-senha"
          />
        </div>

        <div class="col-md-3 mt-1">
          <br />
          <label
            class="btn btn-primary w-100"
            :class="{ disabled: !webhook.ativo }"
            style="cursor: pointer"
          >
            <input type="checkbox" class="d-none" v-model="webhook.ativo" />
            Ativo
          </label>
        </div>

        <div class="col-md-12 mt-2">
          <h4>Eventos</h4>
          <p class="text-muted" style="font-size: 12px">
            Selecione quando esse webhook deve ser notificado.
          </p>
        </div>
        <div class="col-md-3">
          <label
            class="btn btn-primary w-100"
            :class="{ disabled: !eventoSenhaGerada }"
            style="cursor: pointer"
          >
            <input type="checkbox" class="d-none" v-model="eventoSenhaGerada" />
            Senha gerada
          </label>
        </div>
        <div class="col-md-3">
          <label
            class="btn btn-primary w-100"
            :class="{ disabled: !eventoMudancaSetor }"
            style="cursor: pointer"
          >
            <input
              type="checkbox"
              class="d-none"
              v-model="eventoMudancaSetor"
            />
            Mudança de setor
          </label>
        </div>

        <div class="col-md-12 mt-2">
          <h4>Headers</h4>
          <p class="text-muted" style="font-size: 12px">
            Cabeçalhos enviados em toda chamada a esse webhook (ex: um token
            de autenticação exigido pelo parceiro).
          </p>
        </div>
        <div class="col-md-12">
          <div
            v-for="(header, index) in webhook.headers"
            :key="index"
            class="row mb-1"
          >
            <div class="col-md-5">
              <input
                type="text"
                class="form-control"
                placeholder="Nome do header (ex: Authorization)"
                v-model="header.key"
              />
            </div>
            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                placeholder="Valor (ex: Bearer xxxxxxx)"
                v-model="header.value"
              />
            </div>
            <div class="col-md-1">
              <button
                class="btn btn-danger w-100"
                @click="removerHeader(index)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
          <button class="btn btn-secondary mt-1" @click="adicionarHeader">
            <i class="fa fa-plus"></i> Adicionar header
          </button>
        </div>

        <div class="col-md-12 mt-2" v-if="webhook.id">
          <hr />
          <button class="btn btn-outline-primary" @click="testar">
            <i class="fa fa-paper-plane"></i> Testar webhook
          </button>
        </div>

        <div class="col-md-12 text-right">
          <hr />
          <router-link to="/webhooks" class="btn btn-back mr-1">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <a class="btn btn-add" @click="save">
            Salvar
            <i class="fa fa-save"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  name: "WebhookAdd",
  data() {
    return {
      loader: 0,
      webhook: {
        ativo: true,
        headers: [],
      },
      eventoSenhaGerada: false,
      eventoMudancaSetor: false,
    };
  },
  computed: {},
  methods: {
    adicionarHeader: function () {
      const self = this;
      self.webhook.headers.push({ key: "", value: "" });
    },
    removerHeader: function (index) {
      const self = this;
      self.webhook.headers.splice(index, 1);
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "webhooks";

      self.$loading(true);

      const eventos = [];
      if (self.eventoSenhaGerada) {
        eventos.push("senha_gerada");
      }
      if (self.eventoMudancaSetor) {
        eventos.push("mudanca_setor");
      }

      const payload = {
        nome: self.webhook.nome,
        url: self.webhook.url,
        ativo: self.webhook.ativo ? 1 : 0,
        eventos: eventos,
        headers: (self.webhook.headers || []).filter((h) => h.key),
      };

      if (self.webhook.id) {
        api += "/" + self.webhook.id;
        payload._method = "PUT";
      }

      axios
        .post(api, payload)
        .then(() => {
          self.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          self.$loading(false);
          this.$router.push("/webhooks");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    testar: function () {
      const self = this;
      const api = self.$store.state.api + "webhooks/" + self.webhook.id + "/testar";

      self.$loading(true);

      axios
        .post(api)
        .then((response) => {
          const log = response.data;
          if (log && log.sucesso) {
            self.$message(
              "Sucesso",
              `Webhook respondeu com status ${log.status_code}`,
              "success"
            );
          } else {
            self.$message(
              "Atenção",
              `Falha ao chamar o webhook${
                log && log.status_code ? " (status " + log.status_code + ")" : ""
              }`,
              "error"
            );
          }
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getWebhook: function (id) {
      const self = this;
      const api = self.$store.state.api + "webhooks/" + id;

      axios
        .get(api)
        .then((response) => {
          self.webhook = response.data.data[0];
          self.webhook.headers = self.webhook.headers || [];
          self.eventoSenhaGerada = (self.webhook.eventos || []).includes(
            "senha_gerada"
          );
          self.eventoMudancaSetor = (self.webhook.eventos || []).includes(
            "mudanca_setor"
          );
          self.setLoader(50);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    if (id) {
      self.setLoader(50);
      self.getWebhook(id);
    } else {
      self.setLoader(100);
    }
  },
  components: {
    BaseCrud,
  },
};
</script>
<style scoped></style>
